import { CircularProgress, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectGetOrder } from "../../redux/slices/cleverlynkSlice";

interface IOpaqueLoading {}

const OpaqueLoading = (props: IOpaqueLoading) => {
  const getOrder = useSelector(selectGetOrder);
  return useMemo(() => {
    return getOrder.status === "loading" ? (
      <div
        style={{
          position: "fixed",
          height: "100%",
          width: "100%",
          background: "#00000096",
          display: "flex",
          alignItems: "center",
          top: 0,
          left: 0,
          justifyContent: "center",
          zIndex: 9999,
        }}>
        <Grid container direction="column" alignContent="center" alignItems="center">
          <Typography variant="caption" style={{ fontWeight: "bold", textTransform: "uppercase", color: "white" }}>
            Buscando tu orden
          </Typography>
          <CircularProgress size={35} thickness={7} style={{ marginTop: 10, color: "white" }} />
        </Grid>
      </div>
    ) : null;
  }, [getOrder]);
};
export default OpaqueLoading;
